module.exports = __webpack_public_path__ + "media/images/default/shared/footer/facebook-cef8c411116725f9705171450973cebb.svg";